<dl *ngIf="hide && options?.length > 0">
  <dt>{{ title|translate }}</dt>
  <dd>
    <select class="form-control" (change)="selectFilter($event)">
      <option [ngValue]="undefined" [selected]="true" [disabled]="true">{{ 'FILTERS.SELECT_PERIOD'|translate }}</option>
      <option value="{{ option.id }}" *ngFor="let option of options">{{ option.name }}</option>
    </select>
  </dd>
</dl>